import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const PRODUCT_BY_ID_REQUEST = 'sherrinford/product/detail/PRODUCT_BY_ID_REQUEST'
export const PRODUCT_BY_ID_SUCCESS = 'sherrinford/product/detail/PRODUCT_BY_ID_SUCCESS'
export const PRODUCT_BY_ID_ERROR = 'sherrinford/product/detail/PRODUCT_BY_ID_ERROR'

export const STANDARD_REQUEST = 'sherrinford/product/detail/STANDARD_REQUEST'
export const STANDARD_SUCCESS = 'sherrinford/product/detail/STANDARD_SUCCESS'
export const STANDARD_ERROR = 'sherrinford/product/detail/STANDARD_ERROR'

export const PORTFOLIO_REQUEST = 'sherrinford/product/detail/PORTFOLIO_REQUEST'
export const PORTFOLIO_SUCCESS = 'sherrinford/product/detail/PORTFOLIO_SUCCESS'
export const PORTFOLIO_ERROR = 'sherrinford/product/detail/PORTFOLIO_ERROR'

export const POST_REJECT_REASON_REQUEST = 'sherrinford/product/detail/POST_REJECT_REASON_REQUEST'
export const POST_REJECT_REASON_SUCCESS = 'sherrinford/product/detail/POST_REJECT_REASON_SUCCESS'
export const POST_REJECT_REASON_ERROR = 'sherrinford/product/detail/POST_REJECT_REASON_ERROR'

export const UPDATE_PRODUCT_REQUEST = 'sherrinford/product/detail/UPDATE_PRODUCT_REQUEST'
export const UPDATE_PRODUCT_SUCCESS = 'sherrinford/product/detail/UPDATE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_ERROR = 'sherrinford/product/detail/UPDATE_PRODUCT_ERROR'

export const IS_LOADING = 'sherrinford/product/detail/IS_LOADING'
export const DATA = 'sherrinford/product/detail/DATA'
export const ACTION = 'sherrinford/product/detail/ACTION'
export const ACTION_CLEAN = 'sherrinford/product/detail/ACTION_CLEAN'
export const ACTION_ERROR = 'sherrinford/product/detail/ACTION_ERROR'

const initialState = {
  data: {
    logo: '',
    description: '',
    profile: {
      profileId: '',
      about: '',
    },
    productType: {
      name: '',
      slug: '',
    },
    service: {
      name: '',
    },
    format: {
      name: '',
    },
    productLanguage: {
      name: '',
    },
    status: 0,
    country: {
      currencyCode: 'IDR',
      name: '',
    },
    priceFixed: 0,
    viewers: 0,
  },
  isEligible: false,
  isPublished: false,
  portfolios: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  selected: {
    standard: '',
    status: 0,
    rejectReason: '',
  },
  selectionsStandard: [],
  isLoading: false,
  isError: false,
  errorMessage: '',
}

export default createReducer(initialState, {
  [PORTFOLIO_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PORTFOLIO_SUCCESS]: (state, portfolios) => ({
    ...state,
    portfolios,
    isLoading: false,
  }),
  [PORTFOLIO_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
  [STANDARD_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [STANDARD_SUCCESS]: (state, data) => ({
    ...state,
    selectionsStandard: data.rows,
    isLoading: false,
  }),
  [STANDARD_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
  [PRODUCT_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
    errorMessage: '',
  }),
  [PRODUCT_BY_ID_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [PRODUCT_BY_ID_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
  [POST_REJECT_REASON_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_REJECT_REASON_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_REJECT_REASON_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),
  [ACTION]: (state, data) => ({
    ...state,
    selected: {
      ...state.selected,
      [data.field]: data.value,
    },
  }),
  [ACTION_CLEAN]: state => ({
    ...state,
    selected: initialState.selected,
  }),

  [UPDATE_PRODUCT_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [UPDATE_PRODUCT_SUCCESS]: state => ({
    ...state,
    isLoading: false,
    errorMessage: '',
  }),
  [UPDATE_PRODUCT_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
  [ACTION_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
})

export const getPortfolios = (productId, qs, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      PORTFOLIO_REQUEST,
      PORTFOLIO_SUCCESS,
      PORTFOLIO_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/product_portfolio?search={"product":"${productId}"}`,
      payloads: qs,
      authorization: token,
    },
    nextAction: res => cb(res),
  }
}

export const putProduct = (id, product, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      UPDATE_PRODUCT_REQUEST,
      UPDATE_PRODUCT_SUCCESS,
      UPDATE_PRODUCT_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/product/${id}/status`,
      authorization: token,
      payloads: product,
    },
    nextAction: res => cb(res),
  }
}

export const getStandardByProductType = (id, qs) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      STANDARD_REQUEST,
      STANDARD_SUCCESS,
      STANDARD_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/standard?search={"productType":"${id}"}`,
      authorization: token,
      payloads: qs,
    },
  }
}

export const getProductById = (id, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  const dataFilter = JSON.parse(localStorage.getItem('filterPendingProduct'))
  let params = {}
  if (dataFilter) {
    params = {
      sort: dataFilter.sort,
      where: dataFilter.where,
    }

    delete params.sort.isEligible
  }
  return {
    type: [
      PRODUCT_BY_ID_REQUEST,
      PRODUCT_BY_ID_SUCCESS,
      PRODUCT_BY_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/product/${id}`,
      authorization: `${token}`,
      payloads: params,
    },
    nextAction: res => cb(res),
  }
}

export const postRejectReason = (rejectReason, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      POST_REJECT_REASON_REQUEST,
      POST_REJECT_REASON_SUCCESS,
      POST_REJECT_REASON_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/product_reject_reason',
      authorization: token,
      payloads: rejectReason,
    },
    nextAction: res => cb(res),
  }
}

export const setProductAction = data => ({
  type: [ACTION],
  payload: data,
})

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setSelectedClean = () => ({
  type: [ACTION_CLEAN],
})

export const showError = data => ({
  type: [ACTION_ERROR],
  payload: data,
})
